export default "__VITE_ASSET__4f7a2bf0__"